import { createSelector } from '@ngrx/store';
import { getHistoryOrderStatus } from '../getHistoryOrderStatus';

export const isHistoryOrderPlaced = (orderGUID: string) =>
    createSelector(getHistoryOrderStatus(orderGUID), (status) => status === OLO.Enums.ONLINE_ORDER_STATUS.VALIDATED || status === OLO.Enums.ONLINE_ORDER_STATUS.CREATED);
